import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/1dde86ed/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`About patterns`}</h2>
    <p>{`Patterns are best practice solutions for how a user achieves a goal. They show reusable combinations of components and templates that address common user objectives with sequences and flows.`}</p>
    <br />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Production patterns`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/common-actions"
            }}>{`Common actions`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Frequently used actions that appear multiple times across different components and workflows`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/dialog-pattern"
            }}>{`Dialogs`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Prompted when the system needs input from the user or to give the user urgent information concerning their current workflow`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/disabled-states"
            }}>{`Disabled states`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Used to completely remove the interactive function of a component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/empty-states-pattern"
            }}>{`Empty states`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`How to address moments in an app where there is no data to display to the user`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/filtering"
            }}>{`Filtering`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The mechanism by which a user adds or removes data items from a displayed data set`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/forms-pattern"
            }}>{`Forms`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group of related input controls that allows users to provide data or configure options`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/global-header"
            }}>{`Global header`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Covers using UI Shell components for within and between product navigation; introduces techniques for achieving consistency in products`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/loading-pattern"
            }}>{`Loading`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Used when information takes an extended amount of time to process and appear on screen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/login"
            }}>{`Login`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Allows a user to gain access to an application by entering their user ID and password`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/notification-pattern"
            }}>{`Notifications`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An important method of communicating with users and providing feedback`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/overflow-content"
            }}>{`Overflow content`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text, such as a paragraph or a text string, that exceeds a desired space`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/patterns/search-pattern"
            }}>{`Search`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An intuitive method of discovery, offering users a way to explore a website or application using keywords`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      